import { render, staticRenderFns } from "./Sistemas.vue?vue&type=template&id=7da60046&scoped=true&"
import script from "./Sistemas.vue?vue&type=script&lang=js&"
export * from "./Sistemas.vue?vue&type=script&lang=js&"
import style0 from "./Sistemas.vue?vue&type=style&index=0&id=7da60046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da60046",
  null
  
)

export default component.exports